import { ApiResponse } from './types';
import { apiClient } from './core/apiClient';
import { IDashboardStat, IDashboardActivity } from '../types/interfaces/IDashboard';

export async function getDashboardStats(
  userId: string,
  userRole: string
): Promise<ApiResponse<IDashboardStat[]>> {
  const params = new URLSearchParams({ userId, role: userRole });
  return apiClient.get<IDashboardStat[]>(`/dashboard/stats?${params.toString()}`);
}

export async function getDashboardActivity(
  userId: string,
  userRole: string,
  specialty?: string
): Promise<ApiResponse<IDashboardActivity[]>> {
  const params = new URLSearchParams({ userId, role: userRole });
  if (specialty) params.append('specialty', specialty);
  return apiClient.get<IDashboardActivity[]>(`/dashboard/activity?${params.toString()}`);
}
